<div class="dialog-wrapper">
  <h2 mat-dialog-title>
    {{ "partner.campaign.vatInfoDialog.title" | translate }}
  </h2>
  <mat-dialog-content>
    <p class="title">
      {{ "partner.campaign.vatInfoDialog.description" | translate }}
    </p>
    <div class="row">
      <div class="col">
        <mat-form-field style="width: 90%">
          <mat-label>{{
            "partner.campaign.vatInfoDialog.placeholder" | translate
          }}</mat-label>
          <input
            matInput
            #vatNumber="ngModel"
            [(ngModel)]="partner.vatNumber"
            name="shortUrl"
            required
          />
          <mat-error *ngIf="partner.vatNumber && vatNumber.errors">
            {{ "partner.edit.vatIsRequired" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="button-grey" [mat-dialog-close]="" [disabled]="saving">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="button-orange button-save"
      (click)="updatePartner()"
      [disabled]="saving || !partner.vatNumber || vatNumber.errors"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{ "shared.save" | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
